export default __webpack_public_path__ + "static/media/linkedin-image.cb5b6f7f.png";